import type { FC, PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { localeState } from './state';

export const AppIntlProvider: FC<PropsWithChildren<object>> = ({ children }) => {
  const locale = useRecoilValue(localeState);
  return <IntlProvider locale={locale}>{children}</IntlProvider>;
};
